import { render } from "./CourseDrawer.vue?vue&type=template&id=3d8700dc&scoped=true"
import script from "./CourseDrawer.vue?vue&type=script&lang=js"
export * from "./CourseDrawer.vue?vue&type=script&lang=js"

import "./CourseDrawer.vue?vue&type=style&index=0&id=3d8700dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8700dc"]])

export default __exports__